// From: https://stackoverflow.com/a/36894871

const isElement = (element) => {
  return element instanceof Element || element instanceof HTMLDocument;
};

export default isElement;
